import { Box, Button, ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import React from 'react';
import { MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import theme from 'theme/index';

interface AnimatedButtonProps extends ButtonProps {
  /** The text label of the button */
  label: string | React.ReactNode;
  /** Optional icon (default: MdOutlineKeyboardDoubleArrowRight) */
  icon?: React.ReactNode;
  /** Background color */
  bgColor?: string;
  /** Background color on hover */
  hoverColor?: string;
  /** How far the icon should move (in px) */
  moveDistance?: number;
  /** Animation duration in seconds */
  duration?: number;
  /** iconsPosition */
  iconsPosition?: string;
  /** Additional custom styles */
  sx?: SxProps<Theme>;
}

export default function AnimatedButton({
  label,
  icon,
  bgColor = theme.palette.darkBlue.main, // default dark blue
  hoverColor = theme.palette.darkBlue.dark, // slightly darker
  moveDistance = 6,
  duration = 0.6,
  iconsPosition = 'end',
  sx = {},
  ...props
}: AnimatedButtonProps) {
  return (
    <Button
      size="large"
      variant="contained"
      className="font-helvetica-bold"
      {...props}
      sx={{
        height: 'fit-content',
        width: 'fit-content',
        bgcolor: bgColor,
        borderRadius: 3,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        transition: 'background-color 0.3s ease',
        '&:hover': {
          bgcolor: hoverColor,
          '& .arrow-icon': {
            animation: `arrowMove ${duration}s ease-in-out infinite alternate`,
          },
        },
        [`@keyframes arrowMove`]: {
          from: { transform: 'translateX(0)' },
          to: { transform: `translateX(${moveDistance}px)` },
        },
        px: 2,
        ...sx,
      }}
    >
      {iconsPosition === 'start' ? (
        <>
          <Box className="arrow-icon">{icon || <DefaultIcon />}</Box>
          {label}
        </>
      ) : (
        <>
          {label}
          <Box className="arrow-icon">{icon || <DefaultIcon />}</Box>
        </>
      )}
    </Button>
  );
}

const DefaultIcon = () => (
  <Box className="arrow-icon">
    <MdOutlineKeyboardDoubleArrowRight size={'22px'} />
  </Box>
);
